import React, { useState } from "react";
import axios from "axios";
import { useParams, Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Toaster } from "../components/ui/sonner";

const LOGO = "https://i.imgur.com/27IUlf9.png";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const mismatch = pw2.length > 0 && pw !== pw2;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Las contraseñas no coinciden"); return; }
    if (pw.length < 8) { toast.error("Mínimo 8 caracteres"); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: pw });
      toast.success("Contraseña actualizada");
      setTimeout(() => nav("/admin/login"), 1000);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#f7f7f4] flex items-center justify-center p-6">
      <form onSubmit={onSubmit} className="eu-card w-full max-w-md p-8 lg:p-10" data-testid="reset-form">
        <img src={LOGO} alt="" className="h-10 mx-auto" />
        <h1 className="font-display text-3xl text-[#133322] text-center mt-6">Nueva contraseña</h1>
        <div className="mt-8 space-y-4">
          <div>
            <label className="eu-data-label block mb-2">Nueva contraseña</label>
            <input required type="password" minLength={8} value={pw} onChange={(e)=>setPw(e.target.value)} className="w-full bg-[#f7f7f4] rounded-xl px-4 py-3 text-sm border border-[#e5e8e2] focus:border-[#133322] outline-none" data-testid="reset-pw" />
          </div>
          <div>
            <label className="eu-data-label block mb-2">Confirmar contraseña</label>
            <input required type="password" minLength={8} value={pw2} onChange={(e)=>setPw2(e.target.value)} className={`w-full bg-[#f7f7f4] rounded-xl px-4 py-3 text-sm border ${mismatch ? "border-[#b45f3e]" : "border-[#e5e8e2]"} focus:border-[#133322] outline-none`} data-testid="reset-pw2" />
            {mismatch && <div className="text-xs text-[#b45f3e] mt-2" data-testid="reset-mismatch">Las contraseñas no coinciden</div>}
          </div>
        </div>
        <button type="submit" disabled={busy || mismatch} className="eu-btn-primary w-full justify-center mt-8 disabled:opacity-50" data-testid="reset-submit">
          {busy ? "Guardando..." : "Guardar contraseña"}
        </button>
        <div className="mt-6 text-center text-xs"><Link to="/admin/login" className="text-[#5c6b61] hover:text-[#133322]">← Volver al login</Link></div>
      </form>
      <Toaster richColors position="top-center" />
    </div>
  );
}
